<!--
  ~ Copyright (c) 2021.
  ~ 2iPartners SàRL and/or its affiliates.
  ~ All rights reserved.
  ~
  ~ 2iPartners SàRL
  ~ Route de Compois 24,
  ~ 1252 Meinier
  ~ Suisse
  ~
  ~ tel : +41 22 735 97 07
  -->

<div class="page-heading">
  <br>
  <ol class="breadcrumb">
    <li class="breadcrumb-item">
      <a routerLink="/home"><em class="la la-home font-20"></em></a>
    </li>
    <li class="breadcrumb-item">
      <span i18n="@@payPalPaymentCanceled">PayPal payment canceled</span>
    </li>
  </ol>
</div>

<div class="page-content fade-in-up">
  <div class="ibox">
    <div class="ibox-head">
      <div class="ibox-title" i18n="@@payPalPaymentCanceled">PayPal payment canceled</div>
    </div>

    <div class="ibox-body">
      <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 mb-4 text-center">
        <p i18n="@@payPalCanceledInfo">You have canceled your payment.</p>
        <p i18n="@@payPalCanceledQuestion">What do you want to do?</p>
      </div>

      <div class="row">
        <div class="col-12 col-sm-12 col-md-6 col-lg-6 mb-2">
          <button class="btn btn-danger btn-rounded btn-block" i18n="@@payPalCanceledCancelRemoval" (click)="cancel()">
            Cancel removal request
          </button>
        </div>

        <div class="col-12 col-sm-12 col-md-6 col-lg-6 mb-2">
          <button class="btn btn-success btn-rounded btn-block" i18n="@@payPalCanceledReplayRemoval" (click)="replay()"
                  *ngIf="externalRemovalId">
            Replay removal request
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
